import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { loadingBarProviderInjectionKey as A } from "./context.js";
import N from "./styles/index.cssr.js";
import D from "../../_mixins/use-config.js";
import _ from "../../_mixins/use-theme.js";
import { useThemeClass as j } from "../../_mixins/use-css-vars-class.js";
import V from "../styles/light.js";
import { defineComponent as P, inject as k, computed as L, h as C, withDirectives as H, nextTick as R } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as v } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { vShow as I, Transition as K } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
var g = globalThis && globalThis.__awaiter || function(o, t, i, r) {
  function u(s) {
    return s instanceof i ? s : new i(function(n) {
      n(s);
    });
  }
  return new (i || (i = Promise))(function(s, n) {
    function m(l) {
      try {
        a(r.next(l));
      } catch (c) {
        n(c);
      }
    }
    function f(l) {
      try {
        a(r.throw(l));
      } catch (c) {
        n(c);
      }
    }
    function a(l) {
      l.done ? s(l.value) : u(l.value).then(m, f);
    }
    a((r = r.apply(o, t || [])).next());
  });
};
function p(o, t) {
  return `${t}-loading-bar ${t}-loading-bar--${o}`;
}
const Y = P({
  name: "LoadingBar",
  props: {
    containerClass: String,
    containerStyle: [String, Object]
  },
  setup() {
    const {
      inlineThemeDisabled: o
    } = D(), {
      props: t,
      mergedClsPrefixRef: i
    } = k(A), r = v(null), u = v(!1), s = v(!1), n = v(!1), m = v(!1);
    let f = !1;
    const a = v(!1), l = L(() => {
      const {
        loadingBarStyle: e
      } = t;
      return e ? e[a.value ? "error" : "loading"] : "";
    });
    function c() {
      return g(this, void 0, void 0, function* () {
        u.value = !1, n.value = !1, f = !1, a.value = !1, m.value = !0, yield R(), m.value = !1;
      });
    }
    function x() {
      return g(this, arguments, void 0, function* (e = 0, y = 80, b = "starting") {
        if (s.value = !0, yield c(), f)
          return;
        n.value = !0, yield R();
        const d = r.value;
        d && (d.style.maxWidth = `${e}%`, d.style.transition = "none", d.offsetWidth, d.className = p(b, i.value), d.style.transition = "", d.style.maxWidth = `${y}%`);
      });
    }
    function S() {
      return g(this, void 0, void 0, function* () {
        if (f || a.value)
          return;
        s.value && (yield R()), f = !0;
        const e = r.value;
        e && (e.className = p("finishing", i.value), e.style.maxWidth = "100%", e.offsetWidth, n.value = !1);
      });
    }
    function W() {
      if (!(f || a.value))
        if (!n.value)
          x(100, 100, "error").then(() => {
            a.value = !0;
            const e = r.value;
            e && (e.className = p("error", i.value), e.offsetWidth, n.value = !1);
          });
        else {
          a.value = !0;
          const e = r.value;
          if (!e)
            return;
          e.className = p("error", i.value), e.style.maxWidth = "100%", e.offsetWidth, n.value = !1;
        }
    }
    function w() {
      u.value = !0;
    }
    function E() {
      u.value = !1;
    }
    function T() {
      return g(this, void 0, void 0, function* () {
        yield c();
      });
    }
    const $ = _("LoadingBar", "-loading-bar", N, V, t, i), B = L(() => {
      const {
        self: {
          height: e,
          colorError: y,
          colorLoading: b
        }
      } = $.value;
      return {
        "--n-height": e,
        "--n-color-loading": b,
        "--n-color-error": y
      };
    }), h = o ? j("loading-bar", void 0, B, t) : void 0;
    return {
      mergedClsPrefix: i,
      loadingBarRef: r,
      started: s,
      loading: n,
      entering: u,
      transitionDisabled: m,
      start: x,
      error: W,
      finish: S,
      handleEnter: w,
      handleAfterEnter: E,
      handleAfterLeave: T,
      mergedLoadingBarStyle: l,
      cssVars: o ? void 0 : B,
      themeClass: h == null ? void 0 : h.themeClass,
      onRender: h == null ? void 0 : h.onRender
    };
  },
  render() {
    if (!this.started)
      return null;
    const {
      mergedClsPrefix: o
    } = this;
    return C(K, {
      name: "fade-in-transition",
      appear: !0,
      onEnter: this.handleEnter,
      onAfterEnter: this.handleAfterEnter,
      onAfterLeave: this.handleAfterLeave,
      css: !this.transitionDisabled
    }, {
      default: () => {
        var t;
        return (t = this.onRender) === null || t === void 0 || t.call(this), H(C("div", {
          class: [`${o}-loading-bar-container`, this.themeClass, this.containerClass],
          style: this.containerStyle
        }, C("div", {
          ref: "loadingBarRef",
          class: [`${o}-loading-bar`],
          style: [this.cssVars, this.mergedLoadingBarStyle]
        })), [[I, this.loading || !this.loading && this.entering]]);
      }
    });
  }
});
export {
  Y as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/loading-bar/src/LoadingBar.js
// module id = 1663
// module chunks = 41